import React, { useEffect, useState } from 'react';
import PayNowOrder from '../admin/productos/pagos/PayNowOrder';
import PayNowProduct from '../admin/productos/pagos/PayNowProduct';
import PayNowData from '../admin/productos/pagos/PayNowData';
import { createPayLog, generateQrPay, getOrderData, getPaymentInfoClient, verifyMobilePayment } from '../../hooks/api/instapago';
import ValidateMobilePayment from '../admin/productos/pagos/ValidateMobilePayment';
import '../admin/productos/pagos/instapagostStyle.css';
import PopUp from '../general/popUps/PopUp';
import ThanksForPay from '../admin/productos/pagos/ThanksForPay';
import { consolidationWithOdoo } from '../../hooks/api/odoo';

// Componente de Loading Separado
const LoadingSpinner = ({ message, subMessage }) => (
  <div className="card shadow-sm border-0">
    <div className="card-body p-5">
      <div className="text-center">
        <div className="mb-4">
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden"></span>
          </div>
        </div>
        <div>
          <h5 className="text-muted mb-2" style={{ fontSize: '1rem' }}>{message}</h5>
          <p className="text-muted small mb-0" style={{ fontSize: '0.875rem' }}>{subMessage}</p>
        </div>
      </div>
    </div>
  </div>
);

function ClientPay() {
  const [step, setStep] = useState(1)
  const [orderData, setOrderData] = useState([])
  const [loading, setLoading] = useState(false)
  const [verifyingPayment, setVerifyingPayment] = useState(false)
  const [linkActive, setLinkActive] = useState(null)
  const [tasaBancaria, setTasaBancaria] = useState(0)
  const [amount, setAmount] = useState(0)
  const [payQr, setPayQr] = useState({})
  const [paymentInfo, setPaymentInfo] = useState(null)
  const [paymentDataPay, setPaymentDataPay] = useState({})
  const [bankValue, setBankValue] = useState(null);
  const [payType, setPayType] = useState(null)
  const [docType, setDocType] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false)
  const [popUpData, setPopUpData] = useState({message: "", action: "", status: "" });
  const [payLinkId, setPayLinkId] = useState(null)
  const [totalAmountToPay, setTotalAmountToPay] = useState(0)

  // Estado para persistir los datos del formulario
  const [persistentFormData, setPersistentFormData] = useState({
    reference: "",
    phonenumberclient: "",
    clientId: "",
    bank: "",
    date: "",
    amount: "0.00",
  });

  const handleTitle = ['Información del Cliente', 'Detalles del Pago', 'Registrar el Pago'];
  const handleInfo = [
    'Por favor, asegúrate de que toda la información sea correcta. Si es así, presiona "Siguiente". En caso contrario, comunícate con el vendedor para realizar las correcciones necesarias.',
    'Verifica que el monto a pagar coincida exactamente con el valor indicado. Una vez realizado el pago, presiona "Siguiente" para continuar.',
    'Completa los siguientes campos con los detalles de tu pago para poder validar correctamente.'
  ];

  // Función para validar que todos los campos estén llenos
  const validateStep3Fields = () => {
    if (!docType || !paymentDataPay.clientId || !paymentDataPay.reference || !paymentDataPay.bank || !paymentDataPay.date || !paymentDataPay.amount) {
      return false;
    }
    
    // Si es pago móvil, también validar el teléfono
    if (payType === 'mobilePayment' && !paymentDataPay.phonenumberclient) {
      return false;
    }
    
    return true;
  };

  //************************************************* */
  const currentUrl = window.location.href; //Obtener url

  //Obtener id de la factura
  let numOrder = null;
  let entId = null;
  const match = currentUrl.match(/pagar-ahora\/([^\/]+\/\d{4}\/\d{2}\/\d+)\/entId\/([^\/]+)/);
      
  if (match) {
      numOrder = match[1];
      entId = match[2];
  } else {
      console.log("No se pudo extraer la información.");
  }
  const loadOrderData = async () =>{
    setLoading(true);
    if(!numOrder){
      setLoading(false)
      return
    }
    try {
      const orderidParser = numOrder.replaceAll("/", "-")
      const getData = await getOrderData(orderidParser);
      if (!getData) {
        setLinkActive(false)
        setLoading(false);
        return;
      }
      setOrderData(getData.orderData);
      setLinkActive(getData.linkActive)
      setTasaBancaria(getData.tazaCambio)
      setPayLinkId(getData.orderData._id)
      if(getData.linkActive && totalAmountToPay > 0){
        const payQr = await generateQrPay(entId ,orderidParser, {bank: '0134', amount: totalAmountToPay.toFixed(2).toString()})
        setPayQr(payQr)
        setAmount(totalAmountToPay.toFixed(2))
        const getPaymentInfo = (await getPaymentInfoClient()).bankInfos[0]
        setPaymentInfo(getPaymentInfo)
      }
      
    } catch (error) {
      console.error('Error al obtener datos:', error);
    } finally {
      setLoading(false);
    }
  }
  //Ir al siguiente paso
  const nextStep = () =>{
    // Si vamos al paso 3, limpiar datos previos del formulario
    if (step === 2) {
      setPersistentFormData({
        reference: "",
        phonenumberclient: "",
        clientId: "",
        bank: "",
        date: "",
        amount: "0.00",
      });
      setPaymentDataPay({});
      setBankValue(null);
      setDocType(null);
    }
    setStep(step + 1)
  }
  //Retroceder un paso
  const backStep = () =>{
    // Si estamos en el paso 3 y vamos a retroceder, limpiar los datos del formulario
    if (step === 3) {
      setPersistentFormData({
        reference: "",
        phonenumberclient: "",
        clientId: "",
        bank: "",
        date: "",
        amount: "0.00",
      });
      setPaymentDataPay({});
      setBankValue(null);
      setDocType(null);
    }
    setStep(step - 1)
  }

  //Limpia el text y lo preformatea para enviarlo al back
  const formatPhoneNumber = (phone) =>{
    let str = phone.toString().replace(/^0+/, ''); // Elimina todos los ceros al inicio
    return str.startsWith('4') ? str : '4' + str;   // Asegura que empiece con '4'
  }

  // Función para limpiar ceros del inicio de la referencia
  const cleanReference = (reference) => {
    return reference.toString().replace(/^0+/, '');
  };

  //Verificar pago
  const verifyMobilePaymentFn = async () =>{
    // Validar que todos los campos estén llenos
    if (!validateStep3Fields()) {
      setShowPopUp(true);
      setPopUpData({
        message: 'Por favor, completa todos los campos obligatorios antes de validar el pago.',
        action: 'Campos incompletos',
        status: 'warning'
      });
      return;
    }

    const odooJournalId = paymentInfo.odooJournalId;
    if(step === 3){
      setVerifyingPayment(true);
      
      // Preparar los datos del pago fuera del try para que estén disponibles en el catch
      const orderidParser = numOrder.replaceAll("/", "-")
      const banksValue = {
        ...paymentDataPay,  
        bank: bankValue, 
        clientId: `${docType.value}${paymentDataPay.clientId}`, 
        ordernumber: numOrder,
        phonenumberclient: '0058'+formatPhoneNumber(paymentDataPay.phonenumberclient),
        reference: cleanReference(paymentDataPay.reference) // Limpiar ceros del inicio
      }
      
      try {
        console.log('Enviando datos para verificación:', banksValue);
        const verifyMobilePaymentValue = await verifyMobilePayment(entId, orderidParser, banksValue, payType)
        console.log('Respuesta del servidor:', verifyMobilePaymentValue);

        // Usar directamente la respuesta del servidor
        // Verificar si la respuesta es exitosa (puede estar en diferentes niveles)
        const isSuccess = verifyMobilePaymentValue.success || 
                         (verifyMobilePaymentValue.data && verifyMobilePaymentValue.data.success) ||
                         (verifyMobilePaymentValue.data && verifyMobilePaymentValue.data.data && verifyMobilePaymentValue.data.data.success);
        
        if (isSuccess) {
          // Pago validado exitosamente - continuar normalmente
          console.log('Pago validado exitosamente por Instapago');
          
          // Crear log de pago exitoso
          try {
            const issuing_bank = bankValue;
            const receiving_bank = "0134";
            const customer_telephone = '0058'+formatPhoneNumber(paymentDataPay.phonenumberclient);
            const customer_document = `${docType.value}${paymentDataPay.clientId}`;
            const pay_reference = cleanReference(paymentDataPay.reference);
            const pay_method = payType === 'mobilePayment' ? 'mobile_payment' : 'bank_transfer';
            const amount_paid = Number(paymentDataPay.amount);
            const outstanding_balance = 0;
            const voucher = '';
            const odoo_pay_id = odooJournalId;
            const payDate = paymentDataPay.date;
            const instapagoResponse = verifyMobilePaymentValue;
            await createPayLog(entId, {pay_link_id: payLinkId, issuing_bank, receiving_bank, customer_telephone, customer_document, pay_reference, pay_method, amount_paid, outstanding_balance, voucher, odoo_pay_id, payDate, instapagoResponse})
          } catch (logError) {
            console.error('Error al crear log de pago exitoso:', logError);
          }
          
          // Convertir el monto del formato "0.00" a número
          const amountValue = paymentDataPay.amount;
          const data = {
            "billNumber": numOrder,
            "amount": Number(amountValue).toString(),
            "journal_id": odooJournalId,
            "payRef": cleanReference(paymentDataPay.reference)
          }
          await consolidationWithOdoo(data)
          // Limpiar datos del formulario solo en caso de éxito
          setPersistentFormData({
            reference: "",
            phonenumberclient: "",
            clientId: "",
            bank: "",
            date: "",
            amount: "0.00",
          });
          setStep(4)
        } else {
          // Mostrar error usando el mensaje del servidor
          const errorMessage = verifyMobilePaymentValue.message || 
                              (verifyMobilePaymentValue.data && verifyMobilePaymentValue.data.instapagoMessage) ||
                              'Error de validación';
          
          setShowPopUp(true)
          setPopUpData({
            message: errorMessage,
            action: 'Error de validación', 
            status: 'error'
          })
        }
      } catch (error) {
        console.error('Error completo al verificar el pago:', error);
        
        // Siempre crear el log de pago, incluso en caso de error
        try {
          const issuing_bank = bankValue;
          const receiving_bank = "0134";
          const customer_telephone = '0058'+formatPhoneNumber(paymentDataPay.phonenumberclient);
          const customer_document = `${docType.value}${paymentDataPay.clientId}`;
          const pay_reference = cleanReference(paymentDataPay.reference);
          const pay_method = payType === 'mobilePayment' ? 'mobile_payment' : 'bank_transfer';
          const amount_paid = Number(paymentDataPay.amount);
          const outstanding_balance = 0;
          const voucher = '';
          const odoo_pay_id = odooJournalId;
          const payDate = paymentDataPay.date;
          const instapagoResponse = error;
          await createPayLog(entId, {pay_link_id: payLinkId, issuing_bank, receiving_bank, customer_telephone, customer_document, pay_reference, pay_method, amount_paid, outstanding_balance, voucher, odoo_pay_id, payDate, instapagoResponse})
        } catch (logError) {
          console.error('Error al crear log de pago:', logError);
        }
        
        // Determinar el tipo de error y mostrar mensaje específico
        let errorMessage = 'Error de conexión. Por favor, inténtalo de nuevo.';
        let errorAction = 'Error de conexión';
        let errorStatus = 'error';
        
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          console.error('Error de respuesta del servidor:', error.response.status, error.response.data);
          
          // Verificar si la respuesta tiene la estructura esperada del backend
          const errorData = error.response.data;
          
          // Buscar el mensaje en diferentes niveles de la respuesta
          errorMessage = errorData.instapagoMessage || 
                        errorData.message || 
                        (errorData.data && errorData.data.instapagoMessage) ||
                        (errorData.data && errorData.data.message) ||
                        'Error al procesar la solicitud. Por favor, intenta nuevamente.';
          
          errorAction = 'Error de procesamiento';
          errorStatus = errorData.status || 'error';
        } else if (error.request) {
          // La petición fue hecha pero no se recibió respuesta
          console.error('No se recibió respuesta del servidor:', error.request);
          errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión a internet e intenta nuevamente.';
          errorAction = 'Sin conexión';
          errorStatus = 'error';
        } else {
          // Algo pasó al configurar la petición
          console.error('Error al configurar la petición:', error.message);
          errorMessage = 'Error al procesar la solicitud. Por favor, intenta nuevamente.';
          errorAction = 'Error de configuración';
          errorStatus = 'error';
        }
        
        setShowPopUp(true)
        setPopUpData({
          message: errorMessage,
          action: errorAction, 
          status: errorStatus
        })
      } finally {
        setVerifyingPayment(false);
      }
    }
  }
  useEffect(()=>{
    loadOrderData()
  },[totalAmountToPay])
  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {showPopUp && (
        <PopUp setShow={setShowPopUp} message={popUpData.message} action={popUpData.action} status={popUpData.status} />
      )}
      
      {/* Header */}
      <div className="shadow-sm" style={{backgroundColor:'#014788'}}>
        <div className="container py-3">
          <div className="d-flex align-items-center">
            <img 
              src='https://212global.com/wp-content/uploads/2020/08/Logos-de-212.png' 
              alt="212 Global" 
              style={{ height: '40px' }}
            />
            <div className="ms-3">
              <h4 className="text-white mb-0 fw-light" style={{ fontSize: '1.25rem' }}>Portal de Pagos</h4>
              <small className="text-white-50" style={{ fontSize: '0.875rem' }}>Proceso seguro de verificación</small>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">
        {linkActive && step < 4 && (
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* Progress Steps - Completely Redesigned */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4">
                  <div className="row align-items-center">
                    {[1, 2, 3].map((stepNumber, index) => (
                      <div key={stepNumber} className="col-4 text-center">
                        <div className="position-relative">
                          {/* Step Circle */}
                          <div 
                            className={`mx-auto d-flex align-items-center justify-content-center rounded-circle ${
                              step > stepNumber ? 'bg-success text-white' : 
                              step === stepNumber ? 'bg-primary text-white' : 
                              'bg-light text-muted border'
                            }`}
                            style={{
                              width: '60px',
                              height: '60px',
                              border: step > stepNumber ? 'none' : 
                                      step === stepNumber ? 'none' : 
                                      '2px solid #dee2e6',
                              transition: 'all 0.3s ease',
                              boxShadow: step >= stepNumber ? '0 2px 8px rgba(0,0,0,0.15)' : 'none'
                            }}
                          >
                            {step > stepNumber ? (
                              <div className="d-flex flex-column align-items-center">
                                <span className="fw-bold" style={{ fontSize: '15px', lineHeight: '1' }}>{stepNumber}</span>
                                <i className="fas fa-check" style={{ fontSize: '13px', marginTop: '2px' }}></i>
                              </div>
                            ) : (
                              <span className="fw-bold" style={{ fontSize: '20px' }}>{stepNumber}</span>
                            )}
                          </div>
                          
                          {/* Step Title */}
                          <div className="mt-3">
                            <div className={`fw-semibold ${step >= stepNumber ? 'text-dark' : 'text-muted'}`} style={{ fontSize: '13px' }}>
                              {handleTitle[stepNumber - 1]}
                            </div>
                          </div>
                        </div>
                        
                        {/* Progress Line (except for last step) */}
                        {index < 2 && (
                          <div className="position-relative mt-4">
                            <div 
                              className="position-absolute" 
                              style={{
                                top: '50%',
                                left: '30px',
                                right: '30px',
                                height: '3px',
                                backgroundColor: step > stepNumber ? '#28a745' : '#e9ecef',
                                transform: 'translateY(-50%)',
                                borderRadius: '2px',
                                transition: 'background-color 0.3s ease'
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Title and Description */}
              <div className="text-center mb-4">
                <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '1.5rem' }}>{handleTitle[step - 1]}</h2>
                <p className="text-muted lead mb-0" style={{ maxWidth: '600px', margin: '0 auto', fontSize: '1rem' }}>
                  {handleInfo[step - 1]}
                </p>
              </div>
              
              {/* Main Content */}
              {Object.keys(orderData).length > 0 && (
                <div className="card shadow-sm border-0">
                  <div className="card-body p-4">
                    {step === 1 && (
                      <div className="row g-4">
                        <div className="col-12">
                          <div className="card border-0 shadow-sm">
                            <div className="card-header text-white" style={{backgroundColor:'#014788'}}>
                              <h5 className="mb-0" style={{ fontSize: '1.1rem' }}>
                                <i className="fas fa-user me-2"></i>
                                Información del Cliente
                              </h5>
                            </div>
                            <div className="card-body">
                              <PayNowOrder numOrder={numOrder} customerInfo={orderData.customer_info}/>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="card border-0 shadow-sm">
                            <div className="card-header text-white" style={{backgroundColor:'#014788'}}>
                              <h5 className="mb-0" style={{ fontSize: '1.1rem' }}>
                                <i className="fas fa-shopping-cart me-2"></i>
                                Detalles del Producto
                              </h5>
                            </div>
                            <div className="card-body px-2">
                              <PayNowProduct productData={orderData.order_info} saleOrderData={orderData.bill_info} tasaBancaria={tasaBancaria} initialPaymentTerm={orderData.payment_term_info} setTotalAmountToPay={setTotalAmountToPay} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {step === 2 && (
                      <div className="card border-0 shadow-sm">
                        {/* Loading State - Fixed with separate component */}
                            {(loading || verifyingPayment) ? (
                              <LoadingSpinner 
                                message={verifyingPayment ? 'Verificando pago...' : 'Cargando información...'}
                                subMessage={verifyingPayment ? 'Esto puede tomar unos segundos' : 'Obteniendo datos de la orden'}
                              />
                             ) : (
                              <>
                                <div className="card-header bg-info text-white">
                                  <h5 className="mb-0" style={{ fontSize: '1.1rem' }}>
                                    <i className="fas fa-credit-card me-2"></i>
                                    Método de Pago
                                  </h5>
                                </div>
                                <div className="card-body">
                                  <PayNowData amount={totalAmountToPay} paymentInfo={paymentInfo} payQr={payQr} payType={payType} setPayType={setPayType}/>
                                </div>
                              </>
                            )}
                        
                      </div>
                    )}
                    {step === 3 && (
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-warning text-dark">
                          <h5 className="mb-0" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-clipboard-check me-2"></i>
                            Verificación de Pago
                          </h5>
                        </div>

                        {verifyingPayment ? (
                          <LoadingSpinner 
                            message="Verificando pago..." 
                            subMessage="Esto puede tomar unos segundos"
                          />
                        ) : (
                          <>
                        <div className="card-body">
                          <ValidateMobilePayment 
                            amount={totalAmountToPay} 
                            setPaymentDataPay={setPaymentDataPay} 
                            setBankValue={setBankValue} 
                            payType={payType} 
                            docType={docType} 
                            setDocType={setDocType}
                            initialFormData={persistentFormData}
                            setInitialFormData={setPersistentFormData}
                          />
                        </div>
                        </>
                        )}
                      </div>
                    )}

                    {/* Action Buttons */}
                    <div className="d-flex justify-content-between align-items-center mt-4 pt-4 border-top">
                      <div>
                        {step > 1 && step < 4 && (
                          <button 
                            type="button" 
                            className="btn btn-outline-secondary px-4 py-2" 
                            onClick={() => backStep()} 
                            disabled={verifyingPayment}
                            style={{ borderRadius: '8px', fontSize: '0.9rem' }}
                          >
                            <i className="fas fa-arrow-left me-2"></i>
                            Regresar
                          </button>
                        )}
                      </div>
                      <div>
                        {step < 3 && (
                          <button 
                            type="button" 
                            className="btn btn-primary px-4 py-2" 
                            onClick={() => nextStep()} 
                            disabled={(!payType && step > 1) || verifyingPayment}
                            style={{ 
                              borderRadius: '8px',
                              background: 'linear-gradient(135deg, #014788 0%, #0056b3 100%)',
                              border: 'none',
                              boxShadow: '0 2px 4px rgba(1, 71, 136, 0.2)',
                              fontSize: '0.9rem'
                            }}
                          >
                            Siguiente
                            <i className="fas fa-arrow-right ms-2"></i>
                          </button>
                        )}
                        {step === 3 && (
                          <button 
                            type="button" 
                            className="btn btn-success px-4 py-2" 
                            disabled={step < 3 || verifyingPayment || !validateStep3Fields()} 
                            onClick={() => verifyMobilePaymentFn()}
                            style={{ 
                              borderRadius: '8px',
                              background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                              border: 'none',
                              boxShadow: '0 2px 4px rgba(40, 167, 69, 0.2)',
                              fontSize: '0.9rem'
                            }}
                          >
                            <i className="fas fa-check me-2"></i>
                            Aceptar
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Success Step */}
        {step === 4 && (
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <ThanksForPay/>
            </div>
          </div>
        )}

        {/* Expired Link */}
        {linkActive === false && (
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card shadow-sm border-0 text-center">
                <div className="card-body p-5">
                  <div className="mb-4">
                    <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-dark mb-3" style={{ fontSize: '1.5rem' }}>Enlace Expirado</h3>
                  <p className="text-muted mb-4" style={{ fontSize: '1rem' }}>
                    El enlace de pago ha caducado. Por favor, solicita un nuevo enlace de pago.
                  </p>
                  <img 
                    className="img-fluid" 
                    src={require('../../assets/img/jpeg/error-uix.jpeg')} 
                    alt="Error"
                    style={{ maxWidth: '200px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="bg-light border-top mt-5">
        <div className="container py-3">
          <div className="text-center">
            <small className="text-muted" style={{ fontSize: '0.875rem' }}>
              © 2024 212 Global. Todos los derechos reservados. | 
              <span className="ms-2">Proceso seguro de pago</span>
            </small>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientPay